import { ACURA_SITE_NAME } from './index';
import { PaymentFrequency, PaymentMethod } from '../../core/reducers/financialCalculators';
export var getDefaultPaymentOptionsConfig = function (siteName) {
    if (siteName === ACURA_SITE_NAME) {
        return {
            paymentMethod: PaymentMethod.lease,
            paymentFrequency: PaymentFrequency.monthly,
            termAndRate: 48,
        };
    }
    return {
        paymentMethod: PaymentMethod.lease,
        paymentFrequency: PaymentFrequency.weekly,
        termAndRate: 60,
    };
};
export var getDefaultPaymentMethodConfig = function (siteName) {
    var _a, _b;
    if (siteName === ACURA_SITE_NAME) {
        return _a = {},
            _a[PaymentMethod.finance] = {
                term: 84,
                frequency: PaymentFrequency.monthly,
            },
            _a[PaymentMethod.lease] = {
                term: 48,
                frequency: PaymentFrequency.monthly,
            },
            _a[PaymentMethod.cash] = {
                term: 0,
                frequency: PaymentFrequency.monthly,
            },
            _a;
    }
    return _b = {},
        _b[PaymentMethod.finance] = {
            term: 84,
            frequency: PaymentFrequency.weekly,
        },
        _b[PaymentMethod.lease] = {
            term: 60,
            frequency: PaymentFrequency.weekly,
        },
        _b[PaymentMethod.cash] = {
            term: 0,
            frequency: PaymentFrequency.monthly,
        },
        _b;
};
